/**
 * Id for a live user-role echo (websocket `new_message`, role=user).
 *
 * That echo does NOT carry the persisted row id: the orchestrator publishes the
 * stored id under `id`, but `websocket.py::_on_bus_event` reads `message_id` and
 * falls back to a fresh uuid4. Adopting that id as-is made it the newest known
 * message, so the next `silentRefreshConversation` sent `after=<unknown id>`,
 * the server ignored the cursor and returned history, and the real row landed
 * next to the echo — the same user message twice (codex O14-2, seen after a
 * cancel because no assistant/system row with a real id followed the echo).
 *
 * Keeping the echo under the existing `temp-` prefix reuses the one optimistic
 * dedup mechanism: the cursor skips `temp-*`, and the refresh swaps the temp row
 * for the persisted one by content.
 */
export function provisionalEchoId(id: string): string {
  return id.startsWith('temp-') ? id : `temp-echo-${id}`;
}
